














































































































































import { GREEN, RED, YELLOW } from "@/resources/constants/busyReasons";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { Component, Prop, Vue } from "vue-property-decorator";
import { CONFIG, ConfigInterface } from "@/resources/constants/system";
import { PLAN } from "@/resources/constants/plan";
import Plans from "@/resources/mixins/plans/plans";
import { mixins } from "vue-class-component";
@Component({
  name: "chat-menu-component",
})
export default class ChatMenuComponent extends mixins(Plans) {
  [x: string]: any;
  @Prop({ default: false }) openChatList;
  @Prop({ default: false }) openNewChat;
  PLAN = PLAN;
  isTeams = false;
  mounted(): void {
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.isTeams = space?.superSpace?.isTeams;
  }
  get isRoomChatActive(): boolean {
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    const roomId = this.$store.getters["MeetingStore/getRoomId"];

    return (
      roomId !== 0 &&
      (this.$store.getters["SpaceStore/getSpace"].isWebinarChatActive ||
        meetingType !== MEETING_TYPE.WEBINAR) &&
      meetingType !== MEETING_TYPE.SPEED_NETWORKING
    );
  }
  get userChat() {
    return this.$store.getters["ChatStore/getUserChat"];
  }
  get whatIsActiveMenu() {
    const chatType = this.$store.getters["ChatStore/getChatType"];
    if (this.openChatList || chatType == "") return 4;
    if (this.openNewChat) return 5;
    return this.userChat ? 3 : chatType === CHAT_TYPE.SPACE ? 1 : 2;
  }
  get unSeeMessage() {
    return this.$store.getters["ChatStore/getUnSeenMessage"];
  }
  get showUserUnSeenMessages() {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return this.unSeeMessage
      .filter((a) => a.type === CHAT_TYPE.ONE_TO_ONE)
      .filter((a) => {
        const parse = JSON.parse(a.payload.Metadata);
        if (parse.superSpaceId == space.superSpace.id) return true;
        return false;
      }).length;
  }
  get isGeneralChatActive() {
    return this.$store.getters["SpaceStore/getSpace"].isChatActive;
  }
  get minimizeChat(): boolean {
    return this.$store.getters["ChatStore/getMinimizeChat"];
  }
  get config() {
    return this.$store.getters["UserStore/getConfig"];
  }
  saveConfigNotification() {
    this.config.notification.silenceNotification =
      !this.config.notification.silenceNotification;
    this.$store.dispatch("UserStore/setConfigAction", this.config);
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        isNotificationDisabled: this.config.notification.silenceNotification,
      },
      callback: (response) => {
        this.$store.dispatch("UserStore/setConfigAction", this.config);
      },
    });
  }
  saveConfiSendMailChat() {
    this.config.chat.sendMeetingChatConversationToEmail =
      !this.config.chat.sendMeetingChatConversationToEmail;
    this.$store.dispatch("UserStore/setConfigAction", this.config);
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("UserStore/setConfiguration", {
      userId: spaceUser.superSpaceUser.user.id,
      props: {
        sendMeetingChatConversationToEmail:
          this.config.chat.sendMeetingChatConversationToEmail,
      },
      callback: (response) => {
        this.$store.dispatch("UserStore/setConfigAction", this.config);
      },
    });
  }
  showUserIdUnSeenMessages(id) {
    return this.unSeeMessage.filter(
      (a) => a.type === CHAT_TYPE.ONE_TO_ONE && a.id === id
    ).length;
  }
  get showRoomUnSeenMessages() {
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    return this.unSeeMessage.filter(
      (a) =>
        a.type === CHAT_TYPE.ROOM &&
        JSON.parse(a.payload.Metadata).roomId === roomId
    ).length;
  }
  get showSpaceUnSeenMessages() {
    return this.unSeeMessage.filter((a) => a.type === CHAT_TYPE.SPACE).length;
  }
  getRoomName(): string {
    return (
      this.$store.getters["MeetingStore/getRoomName"] ||
      this.$i18n.t("labels.chatNameDefault")
    );
  }
  openInbox() {
    this.$store.dispatch("ChatStore/setMessagesAction", []);
    this.$store.dispatch("ChatStore/setNextTokenAction", null);
    this.$store.dispatch("ChatStore/setChatTypeAction", "");
    this.$emit("open-list", true);
  }
  openGeneralChat(): void {
    this.$store.dispatch("ChatStore/setMessagesAction", []);
    this.$store.dispatch("ChatStore/setUserChatAction", null);
    this.$store.dispatch("ChatStore/setNextTokenAction", null);
    setTimeout(() => {
      this.$store.dispatch("ChatStore/setChatTypeAction", CHAT_TYPE.SPACE);
      this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
        type: CHAT_TYPE.SPACE,
      });

      this.$emit("open-list", false);
    }, 50);
  }
  openRoomChat(): void {
    this.$store.dispatch("ChatStore/setMessagesAction", []);
    this.$store.dispatch("ChatStore/setNextTokenAction", null);
    this.$emit("open-list", false);
    setTimeout(() => {
      this.$store.dispatch("ChatStore/setUserChatAction", null);
      this.$store.dispatch("ChatStore/setChatTypeAction", CHAT_TYPE.ROOM);
      this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
        id: null,
        type: CHAT_TYPE.ROOM,
      });
    }, 50);
  }
  async openUserChat(user): Promise<void> {
    await this.$store.dispatch("ChatStore/setMessagesAction", []);
    await this.$store.dispatch("ChatStore/setUserChatAction", {
      ...user,
      user: user.user,
    });
    await this.$store.dispatch(
      "ChatStore/setChatTypeAction",
      CHAT_TYPE.ONE_TO_ONE
    );
    await this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
      id: user.id,
      type: CHAT_TYPE.ONE_TO_ONE,
    });
    this.$emit("open-user-chat");
  }
  setAvatarColor(color: string): string {
    switch (color) {
      case GREEN.type:
        return GREEN.color;
      case RED.type:
        return RED.color;
      case YELLOW.type:
        return YELLOW.color;
      default:
        return RED.color;
    }
  }
}
